import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 公共路由
export const constantRoutes = [
  {
    path: '/Login',
    component: (resolve) => require(['@/views/Login'], resolve),
    hidden: true
  },
  {
    path: '/schoolweb',
    component: (resolve) => require(['@/views/schoolweb'], resolve),
    hidden: true
  },
  {
    path: '/companyweb',
    component: (resolve) => require(['@/views/companyweb'], resolve),
    hidden: true
  },
  //   学习平台登录页
  {
    path: '/learnPlatformIndex',
    component: (resolve) => require(['@/views/learnPlatformIndex'], resolve),
    hidden: true
  },
  {
    path: '/learnPlatformList',
    component: (resolve) => require(['@/views/learnPlatformList'], resolve),
    hidden: true
  },






































































  // 产品中心
  {
    path: '/productCenter',
    component: (resolve) => require(['@/views/productCenter'], resolve),
    hidden: true
  },
  // 产品中心详情页
  {
    path: '/productCenterDetail',
    component: (resolve) => require(['@/views/productCenterDetail'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailGSP',
    component: (resolve) => require(['@/views/productCenterDetailGSP'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailRetail',
    component: (resolve) => require(['@/views/productCenterDetailRetail'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailWholesaler',
    component: (resolve) => require(['@/views/productCenterDetailWholesaler'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailDisplay',
    component: (resolve) => require(['@/views/productCenterDetailDisplay'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailManage',
    component: (resolve) => require(['@/views/productCenterDetailManage'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailMarketing',
    component: (resolve) => require(['@/views/productCenterDetailMarketing'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetailVR',
    component: (resolve) => require(['@/views/productCenterDetailVR'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail2_1',
    component: (resolve) => require(['@/views/productCenterDetail2_1'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail2_2',
    component: (resolve) => require(['@/views/productCenterDetail2_2'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail2_3',
    component: (resolve) => require(['@/views/productCenterDetail2_3'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail2_4',
    component: (resolve) => require(['@/views/productCenterDetail2_4'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail3_1',
    component: (resolve) => require(['@/views/productCenterDetail3_1'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail3_2',
    component: (resolve) => require(['@/views/productCenterDetail3_2'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail4_1',
    component: (resolve) => require(['@/views/productCenterDetail4_1'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail4_2',
    component: (resolve) => require(['@/views/productCenterDetail4_2'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail4_3',
    component: (resolve) => require(['@/views/productCenterDetail4_3'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail6_1',
    component: (resolve) => require(['@/views/productCenterDetail6_1'], resolve),
    hidden: true
  },
  {
    path: '/productCenterDetail6_2',
    component: (resolve) => require(['@/views/productCenterDetail6_2'], resolve),
    hidden: true
  },
  // 解决方案列表页
  {
    path: '/solution',
    component: (resolve) => require(['@/views/solution'], resolve),
    hidden: true
  },
  // 解决方案详情页
  {
    path: '/solutionCenter',
    component: (resolve) => require(['@/views/solutionDetail'],resolve),
    hidden: true
  },
  // 技能竞赛列表页
  {
    path: '/skillsCompetition',
    component: (resolve) => require(['@/views/skillsCompetition'],resolve),
    hidden: true
  },
  // 技能竞赛详情页
  {
    path: '/skillsCompetitionCenter',
    component: (resolve) => require(['@/views/skillsCompetitionCenter'],resolve),
    hidden: true
  },
  // 关于我们
  {
    path: '/aboutUs',
    component: (resolve) => require(['@/views/aboutUs'],resolve),
    hidden: true
  },


]

export default new Router({
  mode: 'hash', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js